import styled from '@emotion/styled';
import { Icon, Stack, Text, tokens } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

const PreviewBannerWrapper = styled(Stack)`
  position: fixed;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: ${tokens.color.neutral_800};
  color: ${tokens.color.text_default_inverse};
  padding: ${tokens.spacer.x1pt5};
  top: 0;
  height: 52px;
`;

export function PreviewBanner() {
  const { t } = useTranslation('user-test', { keyPrefix: 'common' });

  return (
    <PreviewBannerWrapper spacing="x1">
      <Icon icon="hidden" />
      <Text textColor="text_default_inverse">{t('preview')}</Text>
    </PreviewBannerWrapper>
  );
}
